// The customer portal and the admin console are separate bundles served from
// separate hosts (portal-web -> demo.app.*, admin-web -> console.*). Crossing
// between them is therefore a full navigation to another origin, not a router
// push. Both URLs are injected at build time; when unset (local dev, or a
// single-host deployment) they fall back to "/" so behaviour is unchanged.

const env = import.meta.env as Record<string, string | undefined>;

/** Base URL of the admin console, e.g. https://console.ewigbyte.company */
export const ADMIN_URL = env.VITE_ADMIN_URL || '/';

/** Base URL of the customer portal, e.g. https://demo.app.ewigbyte.company */
export const PORTAL_URL = env.VITE_PORTAL_URL || '/';

function join(base: string, path: string): string {
  if (base === '/') return path;
  return base.replace(/\/$/, '') + path;
}

export const adminUrl = (path = '/') => join(ADMIN_URL, path);
export const portalUrl = (path = '/') => join(PORTAL_URL, path);
